import {
  MY_WORK_BOARD,
  MY_WORK_LAYOUT_VERSION,
  type MyWorkWidgetKey,
} from "@salestrak/widgets";
import { type ManagedWidget, withManagedLayoutVersion } from "./managed-widgets";

export { MY_WORK_LAYOUT_VERSION };

/**
 * Display copy for each My Work board entry. The board DATA (types, configs,
 * layout, defaultOn) lives in @salestrak/widgets — the same
 * module the core API seeds first reads from — so only presentation is defined
 * here. The `MyWorkWidgetKey` union makes a new board entry a typecheck error
 * until it gets copy.
 */
const PRESENTATION: Record<
  MyWorkWidgetKey,
  Pick<ManagedWidget, "label" | "description" | "color">
> = {
  "my-work": {
    label: "My Work",
    description: "A focused snapshot of the projects assigned to you.",
    color: "violet",
  },
  "needs-attention": {
    label: "Needs attention",
    description: "At Risk and Off Track projects that need a next step.",
    color: "orange",
  },
  notepad: {
    label: "Notepad",
    description: "A private space for quick notes and reminders.",
    color: "light-purple",
  },
  "recently-added": {
    label: "Recently added",
    description: "A short list of your newest projects.",
    color: "teal",
  },
  "overview.closed": {
    label: "Newly closed this week",
    description: "Projects created this week that are already in a closed stage.",
    color: "purple",
  },
  activity: {
    label: "Your recent activity",
    description: "A readable feed of the latest project actions you've taken.",
    color: "pink",
  },
  favorites: {
    label: "Favorites",
    description: "Quick access to the projects you've starred.",
    color: "yellow",
  },
};

/**
 * My Work is a curated personal home, not a reporting dashboard. Its 12-column
 * storage grid deliberately uses only 6- and 12-column spans, producing a stable
 * two-column rhythm of half- and full-width snapshots.
 */
export const MY_WORK_WIDGETS: ManagedWidget[] = MY_WORK_BOARD.map((entry) => ({
  ...entry,
  config: withManagedLayoutVersion(MY_WORK_LAYOUT_VERSION, entry.config),
  ...PRESENTATION[entry.widgetKey],
}));
